import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContractEntity, ContractEntityFilter, ContractEntityInfo, ContractVeh, FilterData, FinalBeneficiaryDoc, ContractValidationResult, ContractPermissionData, VinResult, OperationResult, PagedList, TagData, Tag, PermissionRequest} from 'src/app/models';

import { Observable } from 'rxjs';
import { ServicesHelperService } from './services-helper.service';
import { ServicesHelper } from '../helpers';
import { ContractEntityView } from '../models/views/contract-entity-view';
import { UserDataVeh } from '../models/views/user-data-veh';
import { ContractsAssign } from '../models/contracts-assign';
import { HttpService } from './http-service';
import { ContractStep, RequestStatus } from 'src/app/enums';
import { ClientBasicNav } from '../models/views/client-basic-nav';

@Injectable()
export class ContractEntityService {
  url: string;
  contractVehUrl: string;
  constructor(
    private httpClient: HttpClient, 
    @Inject('API_URL') apiUrl: string, 
    private servicesHelperService: ServicesHelperService,
    private httpService: HttpService) {
    this.url = apiUrl + 'contract-entity/';
    this.contractVehUrl = apiUrl + 'contract-veh/';
  }

  generateBeneficiaryReport = (entity: FinalBeneficiaryDoc): Observable<FinalBeneficiaryDoc> =>
    this.httpClient.post<FinalBeneficiaryDoc>(this.url + `beneficiary-report`, entity, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });

  // getBeneficiaryReport = (entity: FinalBeneficiaryDoc): Observable<Blob> =>
  //   this.httpClient.post<Blob>(this.url + `beneficiary-report`, entity, {
  //     responseType: 'blob' as 'json',
  //     headers: ServicesHelper.getHeaders(),
  //   });

  getUniqueFile = (id: number): Observable<Blob> =>
    this.httpClient.get<Blob>(this.url + `single-registration/${id}`, {
      responseType: 'blob' as 'json',
      headers: ServicesHelper.getHeaders(),
    });

  post(entity: ContractEntity): Observable<any> {
    let response: Observable<any> = this.httpClient.post<any>(this.url, entity);
    return response;
  }
  put(entity: ContractEntity): Observable<any> {
    let response: Observable<any> = this.httpClient.put<any>(this.url, entity);
    return response;
  }

  ngOnInit(): void {}

  readMock(id: number): Observable<ContractEntity> {
    var response: Observable<ContractEntity> = this.httpClient.get<ContractEntity>('assets/client.json');
    return response;
  }

  read(id: number, step: ContractStep | null = null): Observable<ContractEntity> {
    let response: Observable<ContractEntity> = this.httpClient.get<ContractEntity>(`${this.url}${id}/${step}`);
    return response;
  }

  getBasicNavByContact(id: number): Observable<Array<ClientBasicNav>> {
    let url = `${this.url}get-basic-clients-nav/${id}`;
    let response: Observable<Array<ClientBasicNav>> = this.httpClient.get<Array<ClientBasicNav>>(url);
    return response;
  }

  getContact(id: number): Observable<ContractEntity> {
    let url = `${this.url}contact/${id}`;
    let response: Observable<ContractEntity> = this.httpClient.get<ContractEntity>(url);
    return response;
  }

  getSale(id: number): Observable<ContractEntity> {
    let url = `${this.url}sale/${id}`;
    let response: Observable<ContractEntity> = this.httpClient.get<ContractEntity>(url);
    return response;
  }

  getDocuments(id: number): Observable<ContractEntity> {
    let url = `${this.url}documents/${id}`;
    let response: Observable<ContractEntity> = this.httpClient.get<ContractEntity>(url);
    return response;
  }

  getPayments(id: number): Observable<ContractEntity> {
    let url = `${this.url}payments/${id}`;
    let response: Observable<ContractEntity> = this.httpClient.get<ContractEntity>(url);
    return response;
  }

  updateContact(entity: ContractEntity): Observable<any> {
    let url = `${this.url}contact`;
    let response: Observable<any> = this.httpClient.put<any>(url, entity);
    return response;
  }

  updateSale(entity: ContractEntity): Observable<any> {
    let url = `${this.url}sale`;
    let response: Observable<any> = this.httpClient.put<any>(url, entity);
    return response;
  }

  updatePayments(entity: ContractEntity): Observable<any> {
    let url = `${this.url}payments`;
    let response: Observable<any> = this.httpClient.put<any>(url, entity);
    return response;
  }

  updateDocuments(entity: ContractEntity): Observable<any> {
    let url = `${this.url}documents`;
    let response: Observable<any> = this.httpClient.put<any>(url, entity);
    return response;
  }
  
  updatePostSale(entity: ContractEntity): Observable<any> {
    let url = `${this.url}postsale`;
    let response: Observable<any> = this.httpClient.put<any>(url, entity);
    return response;
  }

  updateProgress(entityId: number): Observable<any> {
    let url = `${this.url}progress/${entityId}`;
    let response: Observable<any> = this.httpClient.put<any>(url, null);
    return response;
  }
  
  getInfo(): Observable<ContractEntityInfo> {
    let response: Observable<ContractEntityInfo> = this.httpClient.get<ContractEntityInfo>(`${this.url}info`);
    return response;
  }

  getListView(filter: ContractEntityFilter): Observable<Array<ContractEntityView>> {
    let response: Observable<Array<ContractEntityView>> = this.httpClient.post<Array<ContractEntityView>>(`${this.url}view`, filter);
    return response;
  }

  getPagedListView(page, pageSize, filter: ContractEntityFilter): Observable<PagedList<ContractEntityView>> {
    let response = this.httpClient.post<PagedList<ContractEntityView>>(`${this.url}paged-view?page=${page}&pageSize=${pageSize}`, filter);
    return response;
  }

  getList(): Observable<Array<ContractEntity>> {
    let response: Observable<Array<ContractEntity>> = this.httpClient.get<Array<ContractEntity>>(this.url);
    return response;
  }

  getUserDataVeh(): Observable<UserDataVeh> {
    let response: Observable<UserDataVeh> = this.httpService.get<UserDataVeh>(`${this.url}user-data-veh`);
    return response;
  }

  getFilterData = (): Observable<FilterData> => this.httpClient.get<FilterData>(this.url + `filter-data`);

  updateContractsOwner = (contractAssign: ContractsAssign): Observable<void> => this.httpClient.put<void>(this.url + 'update-contracts-owner', contractAssign);

  getValidationResult(contractId: number): Observable<ContractValidationResult> {
    const url: string = this.contractVehUrl + `validate/${contractId}`;
    const response: Observable<ContractValidationResult> = this.httpClient.get<ContractValidationResult>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  updateBillingPermissionStatus(permission: ContractPermissionData): Observable<PermissionRequest> {
    const url = this.contractVehUrl + 'updateBillingPermissionStatus';
    const response: Observable<PermissionRequest> = this.httpClient.put<PermissionRequest>(url, permission,  {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  updateDeleteOperationStatus(permission: ContractPermissionData): Observable<PermissionRequest> {
    const url = this.contractVehUrl + 'updateDeleteOperationStatus';
    const response: Observable<PermissionRequest> = this.httpClient.put<PermissionRequest>(url, permission,  {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  deleteOperation(permission: ContractPermissionData): Observable<OperationResult> {
    const url = this.url + 'delete';
    const response: Observable<OperationResult> = this.httpClient.post<OperationResult>(url, permission,  {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  updateOutputSheetStatus(permission: ContractPermissionData): Observable<PermissionRequest> {
    const url = this.contractVehUrl + 'updateOutputSheetStatus';
    const response: Observable<PermissionRequest> = this.httpClient.put<PermissionRequest>(url, permission,  {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  getOutputSheetPermissionPdf = (contractId: number): Observable<Blob> =>
    this.httpClient.get<Blob>(this.url + `output-sheet-permission-document/${contractId}`, {
      responseType: 'blob' as 'json',
      headers: ServicesHelper.getHeaders(),
    });

  getBillingPermissionPdf = (contractId: number): Observable<Blob> =>
    this.httpClient.get<Blob>(this.url + `billing-permission-document/${contractId}`, {
      responseType: 'blob' as 'json',
      headers: ServicesHelper.getHeaders(),
    });

  searchVehicleByVin(vin: string): Observable<VinResult> {
    let url: string = `${this.url}SearchVehicleByVin/${vin}`;
    let response: Observable<VinResult> = this.httpClient.get<VinResult>(url)
    return response;
  }

  isSalesAdmin(): Observable<boolean> {
    let url: string = `${this.url}is-sales-admin`;
    return this.httpClient.get<boolean>(url);
  }

  canUploadPostsale(contractId: number): Observable<boolean> {
    let url: string = `${this.url}can-upload-postsale?contractId=${contractId}`;
    return this.httpClient.get<boolean>(url);
  }

  getFinancingEntities(): Observable<Tag[]> {
    let url: string = `${this.url}financing-entities`;
    return this.httpClient.get<Tag[]>(url);
  }
}
